/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module IDENTITY REDUCER
 */

import { setAuthenticated } from "./actions";
import { createReducer } from "@reduxjs/toolkit";

// const checkAuthenticated = () => {
//   const ghtkToken = localStorage.getItem("ghtk-token-storage");
//   const checkJson = JSON.parse(ghtkToken);
//   return !!(checkJson != null && checkJson.accessToken);
// };
// State mặc định
const defaultState = {
  isAuthenticated: false,
  user: {},
  isAdmin: false
};
export const reducer = createReducer(defaultState, builder => {
  builder.addCase(setAuthenticated.type, (draff, incomingAction) => {
    const { payload } = incomingAction;
    draff.isAuthenticated = payload.isAuthenticated;
    if (!payload.isAuthenticated || (payload.isAuthenticated && payload.user)) {
      draff.user = payload.user;
      draff.isAdmin = payload.isAdmin;
    }
    return draff;
  });
});
